import { Component, OnInit, ChangeDetectorRef, TemplateRef, AfterViewInit, QueryList, NgZone, OnDestroy, OnChanges, ViewChildren, Output, EventEmitter, ViewChild } from '@angular/core';
import { NgxSpinnerService } from "ngx-spinner";
import { MasterService } from "../../master/services/master-service";
import { CommonHelper } from "../../../helper/helper.component";
import { FormGroup, FormBuilder, Validators, FormControl } from "@angular/forms";
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { Router } from "@angular/router";
import { DataService } from '../../../shared/service/data.service'
import { DatePipe } from '@angular/common';
import { GrievanceDetailsService } from '../../../shared/grievance-details-popup/grievance-details.service'
import { GrievanceViewService } from '../../../shared/grievance-time-line-details/grievance-time-line-details.service';
import { CommonConstants } from 'src/app/shared/constants';
import { FileUploader } from 'ng2-file-upload';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';

declare var $: any;

@Component({
  selector: 'app-supervisor-dashboard',
  templateUrl: './supervisor-dashboard.component.html',
  styleUrls: ['./supervisor-dashboard.component.scss'],
  providers: [MasterService, CommonHelper, DatePipe]
})
export class SupervisorDashboardComponent implements OnInit {
  newGrievanceCount: number = 0;
  newgrievanceData: any = [];
  isnewGrievanceCountExists: boolean = false;
  GrievanceCountExists: boolean = false;
  acceptedGrievanceCount: number = 0;
  acceptedGrievanceData: any = [];
  isacceptedGrievanceCountExists: boolean = false;
  rejectedGrievanceCount: number = 0;
  rejectedGrievanceData: any = [];
  isrejectedGrievanceCountExists: boolean = false;
  grieveanceDetailsData: any;
  dataTable: any;
  modalRef: BsModalRef;
  districtsData: any;
  categoryData: any;
  delUndoGrievnceData: any;
  delUndoGrievnceHeading: string;
  popUpCnfMessage: string;
  gStatus: string;
  id: any;
  beneficaryStatusDetails: any;
  grievanceHistoryData: any;
  categoriesNature: any;
  supervisorDashBoardForm: FormGroup;
  activeTab: string;
  griId: string;
  forwardGrievanceActionForm: FormGroup;
  levelsData: any;
  selectedLevel: any;
  errorCheck: boolean = false;
  forwardLevel: number;
  forwardData: any;
  gLId: any
  modalBool: boolean = false;
  modalView: boolean = false;
  actionTakenData: Array<any> = [];
  fileUploadData: Array<any> = [];
  selectedNature: any;
  natureId: number;
  categoriesNature1: any = [];
  gId: Number;
  isStatus: boolean = false;

  data: any = {
    state_id: '',
    district_id: '',
    complain_id: '',
    block: '',
    register_by: '',
    complain_date: '',
    start_date: '',//2023 - 04 - 03
    end_date: '',//2023 - 04 - 10
    status: ''
  }
  maxDate: any = new Date();
  showPickerStart = false;
  submitted: boolean = false;
  startDateTime: Date = null;
  endDateTime: Date = null;
  showPickerEnd = false;
  showDateEnd = true;
  showTimeEnd = true;
  showDateStart = true;
  showTimeStart = true;
  closeButtonStart: any = { show: true, label: 'Close Me!', cssClass: 'btn btn-sm btn-primary' };
  closeButtonEnd: any = { show: true, label: 'Close Me!', cssClass: 'btn btn-sm btn-primary' };
  levelGrievanceActionData: any = [];
  public uploader: FileUploader = new FileUploader({ url: '', });
  levelGrievanceActionForm: FormGroup;
  actionLevelId: any;
  imageData = [];
  submit: boolean = true;
  redressedStatusData = [];
  userFeedBackForm: FormGroup;
  @ViewChildren(DataTableDirective)
  dtElements: QueryList<DataTableDirective>;
  dtElement: DataTableDirective;

  dtOptions: DataTables.Settings[] = [];

  currentpage: number = 1;
  dtTrigger: Subject<any> = new Subject();
  filterdata:
    {
      state_id: string;
      district_id: string;
      complain_id: string;
      block: string;
      register_by: string;
      complain_date: string;
      start_date: Date;//2023 - 04 - 03
      end_date: Date;//2023 - 04 - 10
      status: string;
    };
  public selectedLang: any;
  public language: any;
  stateData: any;
  districtData: any;
  statusData: any;
  newData: any;
  totalGrievanceCount: any;
  forwardedGrievancecount: any;

  constructor(private masterService: MasterService,
    private spinner: NgxSpinnerService, private chRef: ChangeDetectorRef, public datepipe: DatePipe,
    private modalService: BsModalService, private route: Router, private commonHelper: CommonHelper,
    public dataService: DataService, private fb: FormBuilder, private grievanceDetailsPopupModal: GrievanceDetailsService,
    private grievanceViewService: GrievanceViewService, private ngZone: NgZone) {

  }

  ngOnInit(): void {
    this.actionLevelId = parseInt(localStorage.getItem('levelId'));
    this.language = localStorage.getItem('language');
    this.getDistricts(CommonConstants.stateId);
    this.getCategory();
    this.getAllNewGrievanceData(this.data, 'pending', this.language);
    this.getAllAcceptedGrievanceData(this.data, 'accept');
    this.getAllRejectedGrievanceData(this.data, 'reject');
    this.validationsForFilters();
    this.getStatus()
    this.getLevels(CommonConstants.stateId)
    this.getStates();
    this.redressedStatusData = CommonConstants.statusActionGrievance;
    this.newData = CommonConstants.complaintData;
    this.statusData = CommonConstants.status;
    this.getCounts();
  }


  districts: any = [];
  districtsData1: any;


  //  Method to get getAllGrievancesCounts

  getCounts() {
    this.spinner.show();
    this.masterService.alllevelGrievanceCount('supervisor/total_grievance').subscribe((response: any) => {
      if (response.status == 200) {
        this.spinner.hide();
        this.GrievanceCountExists = true;
        this.totalGrievanceCount = response.data[0].total_grievance;
        this.rejectedGrievanceCount = response.data[0].total_rejected_grievance;
        this.forwardedGrievancecount = response.data[0].total_forwarded_grievance;
        this.newGrievanceCount = response.data[0].total_new_grievance;
      } else {
        this.spinner.hide();
        this.GrievanceCountExists = false
        this.totalGrievanceCount = 0;
        this.rejectedGrievanceCount = 0;
        this.forwardedGrievancecount = 0;
        this.newGrievanceCount = 0;
      }
    },
      (err: any) => {
        this.spinner.hide();

      }
    )
  }

  /* Calling API based on selected Tabs*/
  onSelect(event) {
    this.activeTab = event.heading;
  }

  languageChange(event: any) {
    this.selectedLang = event
    localStorage.setItem('language', this.selectedLang);

    this.dtOptions[0] = {
      destroy: true,
      language: {
        url: this.selectedLang == 'hn' ? '//cdn.datatables.net/plug-ins/1.10.19/i18n/Hindi.json' : '//cdn.datatables.net/plug-ins/1.10.19/i18n/English.json'
      }
    }
    if (this.selectedLang == 'hn' || this.selectedLang == 'en') {
      setTimeout(() => {
        this.dtElements.forEach((dtElement: DataTableDirective, index) => {
          dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            this.getAllNewGrievanceData(this.data, 'pending', event)
            dtInstance.ajax.reload()
            this.chRef.detectChanges();
            dtInstance.draw();
          });
        });
      });
    }

  }

  getStatus() {
    this.beneficaryStatusDetails = [
      { id: '', color: "", name: "", dpname: "All" },
      { id: 1, color: "White", name: "withInSevenDays", dpname: "Within 7 days" },
      { id: 2, color: "Yellow", name: "processing", dpname: "Processing" },
      { id: 3, color: "Red", name: "notRedressed", dpname: "Not Redressed within 7 days" },
      { id: 4, color: "Green", name: "redressed", dpname: "Redressed" }
    ];
  }
  /**getCategory
   *
   * 
   */
  getCategory() {
    this.apiCallingNoState("active_grievanceType");
  }


  /**GetDistricts
   *
   * @param stateId
   */
  getDistricts(stateId: number) {
    this.apiCalling("active_districts", stateId);
  }

  /**
  * @param 
 */
  getLevels(stateId) {
    this.apiCalling("active_levels", stateId);
  }

  getStates() {
    this.masterService.getAll('active_states').subscribe(
      (response: any) => {
        if (response.status == 200) {
          this.stateData = response.data;
          this.stateData = [{ id: '', name: "All" }, ...this.stateData]
        }
      });
  }

  changeState(event: any) {
    this.masterService.getData('active_districts' + "/", event.id).subscribe(
      (response: any) => {
        if (response.status == 200) {
          this.districtsData1 = response.data[0].districts;
          this.districtsData1 = [{ districtId: '', name: "All" }, ...this.districtsData1]
        }

      })


  }


  clearDropdown() {
    this.supervisorDashBoardForm.get('selectedDistrict').setValue(null);
    this.districtsData1 = []
  }

  /**
   *
   * @param url
   * @param id
   */
  apiCalling(url: string, id: number) {
    try {
      this.spinner.show();
      this.masterService.getData(url + "/", id).subscribe(
        (response: any) => {
          if (response.status) {
            this.dataBinding(url, response);
          } else {
            this.spinner.hide();
          }
        },
        error => {
          this.spinner.hide();
        }
      );
    } catch (excp) {
      this.spinner.hide();
    }
  }

  apiCallingNoState(url: string) {
    try {
      this.spinner.show();
      this.masterService.getAll(url).subscribe(
        (response: any) => {
          if (response.status) {
            this.dataBinding(url, response);
          } else {
            this.spinner.hide();
          }
        },
        error => {
          this.spinner.hide();
        }
      );
    } catch (excp) {
      this.spinner.hide();
    }
  }

  /**Databinding to UI
   *
   * @param url
   * @param response
   */
  dataBinding(url: string, response: any) {
    if (url === "active_districts") {
      if (response.data[0].districts.length > 0) {
        this.spinner.hide();
        response.data[0].districts.push({
          code: 'all',
          description: "",
          displayName: "All",
          districtId: "",
          name: 'all',
          status: 'active'
        })
        response.data[0].districts.sort(function (a, b) { return a.districtId - b.districtId });
        this.districtsData = response.data[0].districts;
      } else {
        this.districtsData = [];
        this.spinner.hide();
      }
    } else if (url === "active_grievanceType") {
      if (response.data.length > 0) {
        this.spinner.hide();
        response.data.push({
          description: "",
          grievanceTypeId: "",
          name: 'all',
          status: 'active'
        })
        response.data.sort(function (a, b) { return a.grievanceTypeId - b.grievanceTypeId });
        this.categoryData = response.data;
      } else {
        this.spinner.hide();
        this.categoryData = [];
      }
    }

    if (url === 'active_levels') {
      if (response.data[0].levels.length > 0) {
        if (response.data[0].levels.length > 0) {
          this.spinner.hide();
          this.levelsData = response.data[0].levels
          this.selectedLevel = response.data[0].levels[0];
        } else {
          this.levelsData = [];
          this.spinner.hide();
        }
      }
    }
  }

  validationsForFilters() {
    this.supervisorDashBoardForm = this.fb.group({
      selectedState: [],
      selectedDistrict: [],
      complainId: [],
      register_by: [],
      block: [],
      search: [],
      selectedStatus: [],
      complainDate: [''],
      startDateTime: [''],
      endDateTime: [''],

    });
  }


  /* all New Greviances*/
  getAllNewGrievanceData(data: any, type: string, ev: any) {
    const url = ev == 'hn' ? '//cdn.datatables.net/plug-ins/1.10.19/i18n/Hindi.json' : '//cdn.datatables.net/plug-ins/1.10.19/i18n/English.json';
    const that = this;
    this.filterdata = {
      'state_id': data.state_id,
      'district_id': data.district_id,
      'complain_id': data.complain_id,
      'block': data.block,
      'complain_date': data.complain_date,
      'register_by': data.register_by,
      'status': data.status,
      'start_date': data.start_date,
      'end_date': data.end_date,
    }

    try {
      this.spinner.show();
      this.dtOptions[0] = {
        pagingType: 'full_numbers',
        responsive: true,
        serverSide: true,
        processing: false,
        searching: false, // Add search bar
        destroy: true, //Add to allow the datatable to destroy
        order: [],
        // language: {
        //   url: url

        // },
        ajax: (dataTablesParameters: any, callback) => {
          that.currentpage = (dataTablesParameters.start + dataTablesParameters.length) / dataTablesParameters.length;
          that.masterService.getAllNewGrievances('supervisor/grievance_list/pending' + '?page=' + dataTablesParameters.length + '&currentpage=' + this.currentpage, Object.assign(dataTablesParameters, this.filterdata)).subscribe(
            (response: any) => {
              if (response) {
                this.spinner.hide();
                if (response.status == 200) {
                  this.isnewGrievanceCountExists = true;
                  this.newgrievanceData = response.data.allGrievanceList;
                  this.chRef.detectChanges();

                } else {
                  this.spinner.hide();
                  this.newgrievanceData = [];
                  this.isnewGrievanceCountExists = false;
                  if (this.newgrievanceData.length === 0) {
                    this.isnewGrievanceCountExists = true;
                  }

                  this.chRef.detectChanges();

                }
              }
              callback({
                recordsTotal: response.data.total,
                recordsFiltered: response.data.total,
                data: []
              });
            },
            error => {
              this.spinner.hide();
            }
          );
        },
        columns: [

        ]
      }
    } catch (excp) {
      this.spinner.hide();
    }
  }

  // get levels
  getLevel(stateId: number, gId: number) {
    try {
      this.spinner.show();
      this.masterService.getLevels("levels/", CommonConstants.stateId, this.forwardLevel).subscribe(
        (response: any) => {
          if (response) {
            this.spinner.hide();
            if (response.data.levels.length > 0) {
              this.levelsData = response.data.levels
              this.selectedLevel = response.data.levels[0];
            } else {
              this.levelsData = [];
              this.spinner.hide();
            }
          }
        },
        error => {
          this.spinner.hide();
        }
      );
    } catch (excp) {
      this.spinner.hide();
    }
  }

  /* all New Greviances*/
  getAllAcceptedGrievanceData(data: any, type: string) {
    const that = this;
    if (data.startDate == undefined) {
      data.startDate = "";
    }
    if (data.endDate == undefined) {
      data.endDate = "";
    }

    this.filterdata = {

      'state_id': data.state_id,
      'district_id': data.district_id,
      'complain_id': data.complain_id,
      'block': data.block,
      'complain_date': data.complain_date,
      'register_by': data.register_by,
      'status': data.status,
      'start_date': data.startDate,
      'end_date': data.endDate,
    }
    try {
      this.spinner.show();
      this.dtOptions[1] = {
        pagingType: 'full_numbers',
        responsive: true,
        serverSide: true,
        processing: true,
        searching: false,
        // language: {
        //   url: this.selectedLang=='hn'?'//cdn.datatables.net/plug-ins/1.10.19/i18n/Hindi.json':'//cdn.datatables.net/plug-ins/1.10.19/i18n/English.json',
        // },
        destroy: true, //Add to allow the datatable to destroy
        ajax: (dataTablesParameters: any, callback) => {
          that.currentpage = (dataTablesParameters.start + dataTablesParameters.length) / dataTablesParameters.length;
          that.masterService.getAllAcceptedNewGrievances('supervisor/grievance_list/accept' + '?page=' + dataTablesParameters.length + '&currentpage=' + this.currentpage, Object.assign(dataTablesParameters, this.filterdata)).subscribe(
            (response: any) => {
              if (response) {
                that.spinner.hide();
                if (response.status == 200) {
                  that.chRef.detectChanges();
                  that.isacceptedGrievanceCountExists = true
                  this.acceptedGrievanceData = response.data.allGrievanceList;

                  that.acceptedGrievanceCount = this.acceptedGrievanceData.length; 
                } else {
                  that.spinner.hide();
                  that.isacceptedGrievanceCountExists = false;
                  that.acceptedGrievanceData = [];
                  if (that.acceptedGrievanceData.length === 0) {
                    that.isacceptedGrievanceCountExists = true;
                  }
                  that.chRef.detectChanges();
                }
              }
              callback({
                recordsTotal: response.data.total,
                recordsFiltered: response.data.total,
                data: []
              });
            },
            error => {
              this.spinner.hide();
            }
          );
        },
        columns: [
          { data: 'ID' }
        ]
      }
    } catch (excp) {
      this.spinner.hide();
    }
  }



  /* all New Greviances*/
  getAllRejectedGrievanceData(filterdata: any, type: string) {
    const that = this;
    this.filterdata = {

      'state_id': filterdata.state_id,
      'district_id': filterdata.district_id,
      'complain_id': filterdata.complain_id,
      'block': filterdata.block,
      'complain_date': filterdata.complain_date,
      'register_by': filterdata.register_by,
      'status': filterdata.status,
      'start_date': filterdata.startDate,
      'end_date': filterdata.endDate,
    }
    try {
      this.spinner.show();
      this.dtOptions[2] = {
        pagingType: 'full_numbers',
        responsive: true,
        serverSide: true,
        processing: true,
        searching: false,

        destroy: true, //Add to allow the datatable to destroy        
        ajax: (dataTablesParameters: any, callback) => {
          dataTablesParameters.search;
          that.currentpage = (dataTablesParameters.start + dataTablesParameters.length) / dataTablesParameters.length;

          that.masterService.getAllRejectedGrievances('supervisor/grievance_list/reject' + '?page=' + dataTablesParameters.length + '&currentpage=' + this.currentpage, Object.assign(dataTablesParameters, this.filterdata)).subscribe(
            (response: any) => {
              if (response) {
                that.spinner.hide();
                if (response.status == 200) {
                  that.isrejectedGrievanceCountExists = true
                  that.rejectedGrievanceData = response.data.allGrievanceList;

                  that.chRef.detectChanges();
                } else {
                  that.spinner.hide();
                  that.rejectedGrievanceData = [];
                  that.isrejectedGrievanceCountExists = false;
                  if (that.rejectedGrievanceData.length === 0) {
                    that.isrejectedGrievanceCountExists = true;
                  }
                  that.chRef.detectChanges();

                }
              }
              callback({
                recordsTotal: response.data.total,
                recordsFiltered: response.data.total,
                data: []

              });
            },
            error => {
              that.spinner.hide();
            }
          );
        },
        columns: [

          { data: 'ID' },


        ],
      }
    } catch (excp) {
      this.spinner.hide();
    }
  }

  /* Function for Accepting the Grievance*/
  grievanceStatus(id, status, value, gSValue) {
    let data: any = {
      "status": status
    }
    try {
      this.spinner.show();
      if (gSValue == 'hidePopup') {
        this.modalRef.hide();
      }
      if (value) {
        if (this.undoValue == false) {
          this.masterService.putGrievanceStatus('supervisor/grievance_update_status/' + id + '?status=' + status, {}).subscribe(
            (response: any) => {
              // if(response){
              if (response.status == 200) {
                if (response.data.status == "accept") {
                  this.spinner.hide();
                  this.getAllAcceptedGrievanceData(this.data, 'accept');
                  this.getAllNewGrievanceData(this.data, 'pending', this.language);
                } else if (response.data.status == "reject") {
                  this.spinner.hide();
                  this.getAllRejectedGrievanceData(this.data, '');
                  this.getAllNewGrievanceData(this.data, 'pending', this.language);
                }


                this.getAllNewGrievanceData(this.data, 'pending', this.language);


                this.commonHelper.toasterMessage(response.message);
                this.spinner.hide();
                this.route.routeReuseStrategy.shouldReuseRoute = function () {
                  return false;
                }
                this.route.onSameUrlNavigation = 'reload';
                this.route.navigate(['/supervisor-dashboard'])

              }
            },
            error => {
              this.spinner.hide();
            }
          );
        } else {
          this.masterService.putGrievanceStatus('supervisor/grievance_update_status/' + id + '?status=' + status + '&undo=abc', {}).subscribe(
            (response: any) => {
              if (response.status == 200) {
                if (response.data.status == "pending") {
                  this.spinner.hide();
                  this.getAllNewGrievanceData(this.data, 'pending', this.language);
                  this.getAllRejectedGrievanceData(this.data, 'reject');
                  this.spinner.hide();
                }

                this.getAllNewGrievanceData(this.data, 'pending', this.language);


                this.commonHelper.toasterMessage(response.message);
                this.spinner.hide();
                this.route.routeReuseStrategy.shouldReuseRoute = function () {
                  return false;
                }
                this.route.onSameUrlNavigation = 'reload';
                this.route.navigate(['/supervisor-dashboard'])

              }


            },
            error => {
              this.spinner.hide();
            }
          );
        }

      } else {
        this.spinner.hide();
        this.modalRef.hide();
      }
    } catch (excp) {
      this.spinner.hide();
    }

  }

  /*redraw the datatable*/
  reploatingDataTable(value) {
    let table;
    if (value == 'datatable') {
      table = $("#dataTable").DataTable();
    } else if (value == 'datatable2') {
      table = $("#dataTable2").DataTable();
    } else {
      table = $("#dataTable3").DataTable();
    }
    table.destroy();
  }

  grievanceDetailsModal(grievanceId, status) {
    this.modalBool = true;
    this.masterService.getGrievanceDetails('supervisor/grievance/', grievanceId).subscribe(
      (response: any) => {
        if (response.status == 200) {
          this.grieveanceDetailsData = response.data[0];
          if (status === "Pending") {
            this.masterService.viewSupervisorGrievance('supervisor/view/', grievanceId).subscribe((res: any) => {
              if (res.status === 200) {
                this.openModal();
                console.log(this.language,this.data)
                this.getAllNewGrievanceData(this.data, 'pending', this.language);
                setTimeout(() => {
                  this.dtElements.forEach((dtElement: DataTableDirective) => {
                    dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
                      dtInstance.draw();
                    });
                  });
                });
              }
            })
          }
          else {
            this.openModal();
          }

        } else {
          this.spinner.hide();
        }
      },
      error => {
        this.spinner.hide();
      }
    );
  }

  /* Open the Grievamce Forward Popup Modal*/
  forwardGrievanceModal(template: TemplateRef<any>, grievanceId, grivanceLId) {
    if (this.forwardGrievanceActionForm) {
      this.forwardGrievanceActionForm.reset();
    }
    this.gLId = grivanceLId;
    this.forwardLevel = grievanceId;
    this.getLevel(CommonConstants.stateId, this.forwardLevel)
    this.forwardGrievanceActionForm = this.fb.group({
      level: [this.selectedLevel, [Validators.required]],
      levelfeedback: ['', [Validators.required, Validators.maxLength(250)]]
    });
    this.modalRef = this.modalService.show(template);

  }

  forwardGrivance() {
    try {
      this.spinner.show();
      let apiData = this.forwardGrievanceActionForm.value;
      this.forwardData = {
        grievanceId: this.forwardLevel,
        levelId: apiData.level.levelId,
        comment: apiData.levelfeedback
      }
      this.modalRef.hide();
      this.masterService.postData('forward_grievance', this.forwardData).subscribe((response: any) => {
        if (response) {
          this.spinner.hide();
          if (response.data.length > 0) {
            this.getAllAcceptedGrievanceData(this.data, 'rejected');
            this.commonHelper.toasterMessage(response.message);
            this.spinner.hide();

            this.route.routeReuseStrategy.shouldReuseRoute = function () {
              return false;
            }
            this.route.onSameUrlNavigation = 'reload';
            this.route.navigate(['/supervisor-dashboard'])
          } else {
            this.spinner.hide();
          }
        } else {
          this.spinner.hide();
        }
      });
    } catch (exc) {
      this.spinner.hide();
    }
  }

  /* Opening forward grievance confirmation Popup Model*/
  forwardCnfGrievanceModal(template: TemplateRef<any>) {
    this.modalRef.hide();
    this.modalRef = this.modalService.show(template);
  }

  /*route grievance history screen */
  viewTimeLineGrievance(id) {
    this.modalBool = false;
    this.modalView = true;
    this.masterService.getAll(`grievance_history/${id}`).subscribe(
      (response: any) => {
        if (response.status == 200) {
          this.spinner.hide();
          this.grievanceHistoryData = response.data;
          localStorage.setItem('timeLine', JSON.stringify(this.grievanceHistoryData));
          this.openViewModal();
        } else {
          this.spinner.hide();
          this.grievanceHistoryData = [];
        }
      },
      error => {
        this.spinner.hide();
      }
    );
  }

  /* Function for Opening the View Model*/
  openViewModal() {
    this.grievanceViewService.open();
  }

  /*Redirect to modify-grievance Page */
  editGrievance(formData) {
    this.masterService.viewSupervisorGrievance('supervisor/view/', formData['grievanceId']).subscribe((res:any)=>{
      if(res.status === 200){
      this.dataService.editGrievanceDetails = "editGrievanceDetails";
      this.dataService.getGrievanceDetails(formData);
      localStorage.setItem('formData', JSON.stringify(formData));
      this.route.navigate(["/grievance-register/" + formData['grievanceId']])
      }
    })
  }

  /**
   * deleteGrievance(Grievance)
   * @param template 
   * @param delUndoGdata 
   */
  undoValue: boolean = false;
  updateGrievanceModal(template: TemplateRef<any>, delUndoGdata: any, value: string, grievanceId: string) {
    this.delUndoGrievnceData = delUndoGdata
    this.griId = grievanceId;
    if (value == 'pending') {
      this.delUndoGrievnceHeading = 'Move Grievance'
      this.popUpCnfMessage = 'Are you sure to move this grievance to the list of new grievances?'
      this.gStatus = 'pending'
      this.undoValue = true;
    } else if (value == 'reject') {
      this.delUndoGrievnceHeading = 'Reject Grievance'
      this.popUpCnfMessage = 'Are you sure you want to reject the grievance?'
      this.gStatus = 'reject'
    } else {
      this.delUndoGrievnceHeading = 'Accept Grievance'
      this.popUpCnfMessage = 'Are you sure you want to accept the grievance?'
      this.gStatus = 'accept'
    }
    this.masterService.viewSupervisorGrievance('supervisor/view/', Number(grievanceId)).subscribe((res:any)=>{
      if(res.status === 200){
        this.modalRef = this.modalService.show(template);
        this.getAllNewGrievanceData(this.data, 'pending', this.language);
        setTimeout(() => {
          this.dtElements.forEach((dtElement: DataTableDirective) => {
            dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
              dtInstance.draw();
            });
          });
        });
      }
    }) 
  }


  grievanceActionModal(template: TemplateRef<any>, acceptedGriData) {
    this.submitted = false;
    this.getFiles(acceptedGriData.grievanceId);
    this.levelGrievanceActionData = acceptedGriData;
    this.uploader.queue = [];
    this.isStatus = false;
    this.validationsLevelGrievanceAction();
    this.closeModal()
    this.closeViewModal()
    this.modalRef = this.modalService.show(template, Object.assign({}, { class: 'grievance-modal-wrapper' }));

  }

  closeViewModal() {
    this.grievanceViewService.close();
  }
  closeModal() {
    this.grievanceDetailsPopupModal.close();
  }


  checkRedressal(value) {
    if (value == '1') {
      this.isStatus = true;
      this.levelGrievanceActionForm.addControl('redressedStatus', new FormControl([], Validators.required));
      this.levelGrievanceActionForm.addControl('redressedComment', new FormControl(''));
    } else if (value == '0') {
      this.isStatus = false;
      this.levelGrievanceActionForm.removeControl('redressedStatus')
    }
  }

  validationsLevelGrievanceAction() {
    this.levelGrievanceActionForm = this.fb.group({
      grievanceId: [this.levelGrievanceActionData.id],
      actionLevelId: [this.actionLevelId, [Validators.required]],
      comment: ['', [Validators.required, Validators.maxLength(150)]],
      isGrievanceRedressed: ['0', Validators.required],
    });
    this.levelGrievanceActionForm.removeControl('redressedStatus')
  }


  submitReport(ev: any) {
    let apiData = this.supervisorDashBoardForm.value;
    let stateId: any;
    let districtId: any;
    let statusId: any;
    let endDatetime: any;
    let startDatetime: any;
    if (apiData.selectedState == null) {
      stateId = '';
    } else {
      stateId = apiData.selectedState.id;
    }


    if (apiData.block == null) {
      apiData.block = '';
    } else {
      apiData.block = apiData.block
    }


    if (apiData.complainId == null) {
      apiData.complainId = '';
    } else {
      apiData.complainId = apiData.complainId
    }


    if (apiData.register_by == null) {
      apiData.register_by = '';
    } else {
      apiData.register_by = apiData.register_by;
    }
    if (apiData.selectedDistrict == null) {
      districtId = '';
    } else {
      districtId = apiData.selectedDistrict.districtId
    }
    statusId = apiData.selectedStatus ? apiData.selectedStatus.name : '';
    startDatetime = this.startDateTime ? this.startDateTime : '';
    endDatetime = this.endDateTime ? this.endDateTime : '';
    this.data = {

      state_id: stateId,
      district_id: districtId,
      complain_id: apiData.complainId,
      block: apiData.block,
      register_by: apiData.register_by,
      complain_date: apiData.complainDate,
      search: apiData.search,//Open
      start_date: '',//2023 - 04 - 03
      end_date: '',//2023 - 04 - 10
      status: statusId
    }


    /* Validation for Selecting the Start and End Date */
    let sDate = this.datepipe.transform(startDatetime, "yyyy-MM-dd HH:mm:ss"),
      eDate = this.datepipe.transform(endDatetime, "yyyy-MM-dd HH:mm:ss");

    if (sDate) {
      if (eDate) {
        if (sDate >= eDate) {
          this.submitted = true;
        } else {
          this.submitted = false;
        }
      } else {
        this.submitted = false;
      }
    } else {
      this.submitted = false;
    }

    /* Calling API Only when the Start Date is not greater than than the End Date */
    if (this.submitted === false) {
      this.getAllNewGrievanceData(this.data, 'pending', ev);
      setTimeout(() => {
        this.dtElements.forEach((dtElement: DataTableDirective) => {
          dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw();
          });
        });
      });
    }

  }

  // function to append value in input 
  onValueChange(val: any, endorstart: string) {
    if (endorstart === 'startDT') {
      val = this.datepipe.transform(val, "yyyy-MM-dd")
      this.startDateTime = val;
      this.submitted = false;
    }
  }

  // toggle function to show datetime picker modal
  onTogglePicker(value: string) {
    if (value == 'startDT') {
      if (!this.showPickerStart) {
        this.showPickerStart = true;

      }
    }
    if (value == 'endDT') {
      if (!this.showPickerEnd) {
        this.showPickerEnd = true;
      }
    }
  }

  //function to diaable or enable the submit button
  emptyDisable(event) {
    if (event.target.value.length <= 250) {
      this.errorCheck = false;
    } else if (event.target.value.length > 250) {
      this.errorCheck = true;
    }
  }


  /* Function for Opening the Password Popup Model*/
  openModal() {
    this.grievanceDetailsPopupModal.open();
  }

  /*getData bind table data */
  getFiles(id) {
    try {
      this.spinner.show();
      this.openModal();
      this.masterService.getAll('grievance_uploads/' + id).subscribe(
        (response: any) => {
          if (response.data.length > 0) {
            this.spinner.hide();
            this.actionTakenData = response.data;
            this.actionTakenData.map(item => {
              if (item.isGrievanceRedressed == 1) {
                item.isGrievanceRedressedVal = "Yes";
              } else {
                item.isGrievanceRedressedVal = "No"
              }
              this.fileUploadData = item.uploads
            })

          } else {
            this.spinner.hide();
            this.actionTakenData = [];
          }
        },
        error => {
          this.spinner.hide();
        }
      );
    } catch (exc) { }
  }

  // get grievance nature id 
  getGrievanceNature1(id) {
    try {
      this.spinner.show();
      this.masterService.getData('active_grievanceNature/', id).subscribe((response: any) => {
        if (response.status) {
          let newData = [];
          this.spinner.hide();
          response.data.filter(newResponse => {
            newData.push({ id: newResponse.grievanceNatureId, name: newResponse.grievanceNatureName });
          });
          if (newData.length > 0) {
            this.spinner.hide();
            this.categoriesNature1 = newData;
          } else {
            this.categoriesNature1 = [];
          }
          this.spinner.hide();
        } else {
          this.spinner.hide();
        }
      }, error => {
        this.spinner.hide();
      })

    } catch (excp) {
      this.spinner.hide();
    }
  }
  get addlevelGrievanceF() {
    return this.levelGrievanceActionForm.controls;
  }

  addLevelGrievanceAction() {
    this.submitted = true;
    this.submit = false;
    this.imageData = [];
    let fileLength;
    fileLength = this.uploader.queue
    let fileCount: number = fileLength.length;
    if (fileCount > 0) {
      fileLength.forEach((val, i, array) => {
        let fileReader = new FileReader();
        fileReader.onloadend = (e) => {
          this.imageData.push(fileReader.result);
        }
        fileReader.readAsDataURL(val._file);
      });
    }
    if (this.levelGrievanceActionForm.invalid) {
      this.spinner.hide();
      return;
    }
    let redrssStatus;
    let apiData1 = this.levelGrievanceActionForm.value, supData: any;
    if (this.isStatus == false) {
      if (apiData1.redressedStatus == undefined) {
        redrssStatus = apiData1.redressedStatus = "";
      }
    } else if (this.isStatus == true) {
      redrssStatus = apiData1.redressedStatus.dpname;
    }
    setTimeout(() => {
      supData = {
        grievanceId: apiData1.grievanceId ? apiData1.grievanceId : '',
        levelId: apiData1.actionLevelId ? apiData1.actionLevelId : '',
        comment: apiData1.comment ? apiData1.comment : '',
        file: this.imageData,
        isGrievanceRedressed: parseInt(apiData1.isGrievanceRedressed),
        redressedStatus: redrssStatus ? redrssStatus : '',
        redressedComment: apiData1.redressedComment ? apiData1.redressedComment : ''
      }
      this.apiCallForPostData("level/grievance_action", supData);
    }, 500)
  }

  apiCallForPostData(url: string, supData) {
    try {
      this.spinner.show();
      let data2
      this.masterService.postData(url, supData).subscribe((response: any) => {
        data2 = response.data
        if (response.status) {
          if (url === 'level/grievance_action') {
            if (response.status) {
              this.spinner.hide();
              this.commonHelper.toasterMessage(response.message);
              this.levelGrievanceActionForm.reset();
              this.uploader.queue = [];
              this.submitted = false;
              this.getAllNewGrievanceData(data2, 'pending', this.language);

              this.levelGrievanceActionForm.controls['grievanceId'].setValue(this.levelGrievanceActionData.id);
              this.levelGrievanceActionForm.controls['actionLevelId'].setValue(this.actionLevelId);
              this.levelGrievanceActionForm.controls['isGrievanceRedressed'].setValue('0');
              this.isStatus = false;
              this.modalRef.hide();
              this.route.routeReuseStrategy.shouldReuseRoute = function () {
                return false;
              }
              this.route.onSameUrlNavigation = 'reload';
              this.route.navigate(['/supervisor-dashboard'])
            } else {
              this.spinner.hide();
              this.commonHelper.toasterMessageError(CommonConstants.validationMessage);
            }
          }
        } else {
          this.spinner.hide();
          this.commonHelper.toasterMessageError(CommonConstants.validationMessage)
        }
      }, error => {
        this.spinner.hide();
      });
    } catch (exc) {
      this.spinner.hide();
    }
  }

  grievanceUserFeedBackModal(template: TemplateRef<any>, grievanceId) {
    if (this.userFeedBackForm) {
      this.userFeedBackForm.reset();
    }
    this.userFeedBackForm = this.fb.group({
      feedbackComment: ['', Validators.maxLength(250)],
      feedbackStatus: [true, Validators.required]
    });
    this.gId = grievanceId;
    this.modalRef = this.modalService.show(template);
  }

  /*submit FeedBack*/
  submitUserFeedback() {
    try {
      let apiValues = this.userFeedBackForm.value,
        status = apiValues.feedbackStatus ? 'satisfied' : 'unsatisfied',
        data = {
          "grievanceId": this.gId,
          "feedback": status,
          "comment": apiValues.feedbackComment,
        }
      this.modalRef.hide();
      this.masterService.postData('grievance_feedback', data).subscribe(
        (response: any) => {
          if (response.data.length > 0) {
            this.commonHelper.toasterMessage(response.message);
          } else {
            this.spinner.hide();
          }
        },
        error => {
          this.spinner.hide();
        }
      );
    } catch (exc) { }
  }


  onNatureChange(value) {
    this.selectedNature = value
    this.natureId = value.id;
  }

  /**
 * categorychange
 * @param event
 */
  onAddCategoryChange(event: any, value) {
    if (event) {
      this.supervisorDashBoardForm.controls['filterGrievanceNature'].reset();
      this.gId = event.grievanceTypeId;
      if (typeof (event.grievanceTypeId) == 'string') {
        this.gId = 0
      }
      this.getGrievanceNature1(this.gId);
    } else {
      this.gId = 1;
    }
  }
}
